import { InjectionToken } from '@angular/core';
import { ConsentTemplatesService, FormTemplatesService } from '@services';

export const FORM_TEMPLATES_SERVICE = new InjectionToken<FormTemplatesService>(
  'FORM_TEMPLATES_SERVICE'
);

export const CONSENT_TEMPLATES_SERVICE =
  new InjectionToken<ConsentTemplatesService>('CONSENT_TEMPLATES_SERVICE');
